export default __webpack_public_path__ + "static/media/ledger_white.06ec61c7.svg";